import { AdminState } from './state';

export const getters = {
  adminUsers: (state: AdminState) => state.users,
  adminOneUser: (state: AdminState) => (userId: number) => {
    const filteredUsers = state.users.filter((user) => user.id === userId);
    if (filteredUsers.length > 0) {
      return { ...filteredUsers[0] };
    }
  },
  contracts: (state: AdminState) => state.contracts,
  services: (state: AdminState) => state.services,
  oneService: (state: AdminState) => (serviceId: number) => {
    const filteredServices = state.services.filter((service) => service.id === serviceId);
    if (filteredServices.length > 0) {
      return { ...filteredServices[0] };
    }
  },
  serviceBanPolicies: (state: AdminState) => state.serviceBanPolicies,
  oneServiceBanPolicy: (state: AdminState) => (serviceBanPolicyId: number) => {
    const filteredServiceBanPolicies = state.serviceBanPolicies.filter(
      (serviceBanPolicy) => serviceBanPolicy.id === serviceBanPolicyId,
    );
    if (filteredServiceBanPolicies.length > 0) {
      return { ...filteredServiceBanPolicies[0] };
    }
  },
  senders: (state: AdminState) => state.senders,
  oneSender: (state: AdminState) => (senderId: number) => {
    const filteredSenders = state.senders.filter((sender) => sender.id === senderId);
    if (filteredSenders.length > 0) {
      return { ...filteredSenders[0] };
    }
  },
  templates: (state: AdminState) => state.templates,
  oneTemplate: (state: AdminState) => (templateId: number) => {
    const filteredTemplates = state.templates.items.filter((template) => template.id === templateId);
    if (filteredTemplates.length > 0) {
      return { ...filteredTemplates[0] };
    }
  },
  proxyErrors: (state: AdminState) => state.proxyErrors,
  oneProxyError: (state: AdminState) => (proxyErrorId: number) => {
    const filteredProxyErrors = state.proxyErrors.filter((proxyError) => proxyError.id === proxyErrorId);
    if (filteredProxyErrors.length > 0) {
      return { ...filteredProxyErrors[0] };
    }
  },
  priorities: (state: AdminState) => state.priorities,
  mnos: (state: AdminState) => state.mnos,
  oneMNO: (state: AdminState) => (mnoId: number) => {
    const filteredMNOs = state.mnos.filter((mno) => mno.id === mnoId);
    if (filteredMNOs.length > 0) {
      return { ...filteredMNOs[0] };
    }
  },
  mnoMasks: (state: AdminState) => state.mnoMasks,
  mnoSenders: (state: AdminState) => state.mnoSenders,
  templateProxyResponse: (state: AdminState) => state.templateProxyResponse,
  checkMNOMaskResponse: (state: AdminState) => state.checkMNOMaskResponse,
  tags: (state: AdminState) => state.tags,
};
